import { Typography } from "@/design-system/Atoms";
import PatientBillOfRightsLayout from "./PatientBillOfRightsLayOut";
import { patientBillOfRightsData } from "./patientBillOfRights.data";
import { useScrollToSection } from "@/hooks/useScrollToSection";

export const PatientBillOfRightsTemplate = () => {
  const { ref } = useScrollToSection<HTMLElement>({
    behavior: "smooth",
    block: "start",
    offset: 80,
  });
  return (
    <>
      <section
        ref={ref}
        id="patient-bill-of-right"
        className="contact-form bg-white"
      >
        <div className="container mx-auto mt-8 px-4">
          <Typography variant="sectionDescriptionLarge" as="p" className="mb-1">
            Defy Medical Patient Bill of Rights and Code of Conduct
          </Typography>

          {patientBillOfRightsData.map((section, idx) => (
            <div className="mb-8" key={idx}>
              <PatientBillOfRightsLayout
                heading={section.heading}
                content={section.content}
                className="mb-1"
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
export default PatientBillOfRightsTemplate;
